import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import PlateModal from '../../components/modals/PlateModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Plates extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {number: '', notes: ''};
    this.state = {redirect: false, plates: [], filteredPlates: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getPlates = this.getPlates.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getPlates();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getPlates() {
    axios.get(`${Configuration.apiServer}/api/v1/plates`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({plates: resp.data, filteredPlates: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/plates/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getPlates();
    });
  }

  handleSearch(event) {
    const plates = this.state.plates.filter(plate => {
      return plate.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredPlates: plates});
  }

  handleOpenModal(kind, record) {
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/plates`, {plate: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getPlates();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/plates/${this.state.current.id}`, {plate: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getPlates();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of plates
    const plates = this.state.filteredPlates.map(plate => {
      return (
        <Card
          style={{ width: '24%', margin: '10px 0px' }}
          actions={[<Icon type="eye" style={{ color: '#ccc' }} />, <Icon type="edit" onClick={() => { this.handleOpenModal('edit', plate) }} />]}
          key={plate.id}
        >
          <Meta
            avatar={<Avatar icon="car" />}
            title={plate.number}
            description={<span className={`cursor text-${Configuration.getStatus(plate.status).color}`} onClick={() => { this.handleStatus(plate.id) }}>{Configuration.getStatus(plate.status).text}</span>}
          />
          <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>{plate.notes}</p>
        </Card>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Lista negra</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            {plates}
          </div>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />

        <PlateModal visible={this.state.modalVisible} title={"Nueva placa"} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />
      </div>
    );
  }
}

export default Plates;



// WEBPACK FOOTER //
// ./src/pages/admin/Plates.js